import React from "react";

const RiskInformation = ({ data, className }) => {
  return (
    <section>
      <div className={className}>
        <div>
          <h4>Risk Score Indicator</h4>
        </div>
      </div>
      {data.map(riskExtension => {
        const eiiaRisk = {
          Value: riskExtension.valueString
        };

        return (
          <div className={className}>
            <div>
              <div>{eiiaRisk.Value}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default RiskInformation;
